import { ref } from 'vue';

const predictedItemCount = ref(null);

export function useCartPrediction() {
  const setPrediction = (count) => {
    predictedItemCount.value = count;
  };

  const clearPrediction = () => {
    predictedItemCount.value = null;
  };

  return {
    clearPrediction,
    predictedItemCount,
    setPrediction,
  };
}
